export const defaultTemporaryBrowsingState = {
    cxmFilmsForComponent: {}
};
//# sourceMappingURL=state.js.map